import React from "react";

export default function Terms() {
  const updated = "September 1, 2025";

  return (
    <main className="py-10">
      <div className="container-x space-y-6">
        {/* Header */}
        <header className="text-center md:text-left">
          <p className="uppercase tracking-[0.2em] text-[#D4FF00] font-extrabold text-xs">
            Terms
          </p>
          <h1 className="text-3xl md:text-4xl font-extrabold mt-1">Terms & Conditions</h1>
          <p className="text-neutral-400 text-sm mt-1">Last updated: {updated}</p>
        </header>

        {/* Acceptance */}
        <section id="acceptance" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">1. Acceptance of Terms</h2>
          <p className="text-neutral-400 text-sm">
            By visiting the venue, booking a session, or using this website, you agree to these Terms.
            If you do not agree, please do not use our services.
          </p>
        </section>

        {/* Bookings & Payment */}
        <section id="booking" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">2. Bookings, Deposits & Payment</h2>
          <ul className="text-neutral-300 text-sm space-y-2">
            <li>• Bookings are first-come, first-served. We may request a deposit for groups.</li>
            <li>• Late arrivals may reduce playtime. No-shows may be charged per-seat for up to one hour.</li>
            <li>• Prices are shown before checkout and may change over time.</li>
          </ul>
        </section>

        {/* Conduct */}
        <section id="conduct" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">3. Conduct & Fair Play</h2>
          <ul className="text-neutral-300 text-sm space-y-2">
            <li>• Be respectful; harassment, cheating, and exploiting are not allowed.</li>
            <li>• Use your own publisher accounts; follow each game’s EULA/ToS.</li>
            <li>• Damage caused by misuse may be billed at repair/replacement cost.</li>
          </ul>
        </section>

        {/* Content & Accounts */}
        <section id="accounts" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">4. Accounts, Content & Streaming</h2>
          <p className="text-neutral-400 text-sm">
            You are responsible for your accounts and any content you access or stream while on our rigs.
            Respect copyright and platform rules.
          </p>
        </section>

        {/* Disclaimer */}
        <section id="disclaimer" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">5. Disclaimers</h2>
          <p className="text-neutral-400 text-sm">
            Services are provided “as-is” and “as available.” We do not guarantee uninterrupted access,
            specific frame rates, ping, or availability of any title.
          </p>
        </section>

        {/* Liability */}
        <section id="liability" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">6. Limitation of Liability</h2>
          <p className="text-neutral-400 text-sm">
            To the maximum extent permitted by law, we are not liable for indirect, incidental, or
            consequential damages arising from use of our services or equipment.
          </p>
        </section>

        {/* Changes */}
        <section id="changes" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">7. Changes to these Terms</h2>
          <p className="text-neutral-400 text-sm">
            We may update these Terms periodically. Material changes will be posted on this page with a new “Last updated” date.
          </p>
        </section>

        {/* Governing law */}
        <section id="law" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">8. Governing Law</h2>
          <p className="text-neutral-400 text-sm">
            These Terms are governed by the laws of British Columbia and applicable federal laws of Canada.
          </p>
        </section>

        {/* Contact */}
        <section id="contact" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">9. Contact</h2>
          <p className="text-neutral-400 text-sm">
            Questions? Email <a className="underline hover:text-[#D4FF00]" href="mailto:info@revytech.ca">info@revytech.ca</a>.
          </p>
        </section>

        <p className="text-xs text-neutral-500">
          This page is provided for general information and is not legal advice.
        </p>
      </div>
    </main>
  );
}
